export default __webpack_public_path__ + "d934c1440f89cb47c611986cce6c09a4.png";